import React from 'react';
import { withRouter } from 'react-router';
import cx from 'classnames';

import { NavBar } from 'src/screens/navBar';
import { useWindowDimensions } from 'src/utils';
import { useConfigSelectors } from 'src/@app/reducers';

const SplitLayoutScreen = props => {
  const configSelectors = useConfigSelectors();
  const isPortrait = configSelectors.getIfPortraitLayout();

  const { width } = useWindowDimensions();
  const breakpoint = 1280;

  return (
    <NavBar>
      <div
        className={cx('page-wrapper', {
          'page-wrapper--landscape': !isPortrait,
          'table--slim': !isPortrait || width < breakpoint,
        })}>
        {props.children}
      </div>
    </NavBar>
  );
};

export const SplitLayout = withRouter(SplitLayoutScreen);
